// @ts-nocheck
const getContentSearchUrl = (query: string, searchPath: string, currentTab: string) => {
    const encodedQuery = encodeURIComponent(query);
    const currentTabQueryString = `&currentTab=${currentTab}`;
    return `/${searchPath}?query=${encodedQuery}${currentTabQueryString}`;
};

export default getContentSearchUrl;
